<template>
  <div class="landing-page">
    <hero />

    <section class="information-section" aria-labelledby="information-title">
      <div class="container">
        <div class="section-heading">
          <div>
            <span class="section-kicker">Información importante</span>
            <h2 id="information-title">Entrega del Bono Juancito Pinto 2026</h2>
          </div>
          <p>
            Consulta las fechas de pago y el cronograma de cobro establecido
            para las ciudades capitales y El Alto.
          </p>
        </div>

        <div class="information-grid">
          <button
            type="button"
            class="information-card"
            aria-label="Ampliar período de entrega del Bono Juancito Pinto 2026"
            @click="zoomImage(paymentPeriodImage)"
          >
            <img
              :src="paymentPeriodImage"
              alt="Período de entrega del Bono Juancito Pinto 2026: del 26 de octubre al 6 de diciembre"
              loading="lazy"
              decoding="async"
            />
            <span>
              Período de entrega <i class="bx bx-expand-alt" aria-hidden="true"></i>
            </span>
          </button>

          <button
            type="button"
            class="information-card"
            aria-label="Ampliar cronograma de restricciones de cobro"
            @click="zoomImage(restrictionsImage)"
          >
            <img
              :src="restrictionsImage"
              alt="Cronograma de entrega para la modalidad de cobro en cajas"
              loading="lazy"
              decoding="async"
            />
            <span>
              Restricciones de cobro <i class="bx bx-expand-alt" aria-hidden="true"></i>
            </span>
          </button>
        </div>
      </div>
    </section>

    <section id="accesos" class="quick-section" aria-labelledby="quick-title">
      <div class="container">
        <div class="section-heading">
          <div>
            <span class="section-kicker">Accesos principales</span>
            <h2 id="quick-title">¿Qué necesitas consultar?</h2>
          </div>
          <p>
            Encuentra rápidamente los servicios e información más importantes
            del Bono Juancito Pinto.
          </p>
        </div>

        <div class="quick-grid">
          <router-link :to="{ name: 'public-search' }" class="quick-card quick-card--featured">
            <span class="quick-number">01</span>
            <span class="quick-icon"><i class="bx bx-search-alt-2"></i></span>
            <div>
              <h3>Consultar beneficio</h3>
              <p>Verifica la habilitación y el estado del pago.</p>
            </div>
            <i class="bx bx-right-arrow-alt quick-arrow" aria-hidden="true"></i>
          </router-link>

          <router-link :to="{ name: 'public-info' }" class="quick-card">
            <span class="quick-number">02</span>
            <span class="quick-icon"><i class="bx bx-list-check"></i></span>
            <div>
              <h3>Requisitos</h3>
              <p>Conoce los documentos necesarios para el cobro.</p>
            </div>
            <i class="bx bx-right-arrow-alt quick-arrow" aria-hidden="true"></i>
          </router-link>

          <router-link :to="{ name: 'public-entities' }" class="quick-card">
            <span class="quick-number">03</span>
            <span class="quick-icon"><i class="bx bx-building-house"></i></span>
            <div>
              <h3>Entidades autorizadas</h3>
              <p>Ubica los puntos habilitados en tu departamento.</p>
            </div>
            <i class="bx bx-right-arrow-alt quick-arrow" aria-hidden="true"></i>
          </router-link>

          <router-link :to="{ name: 'public-contacts' }" class="quick-card">
            <span class="quick-number">04</span>
            <span class="quick-icon"><i class="bx bx-headphone"></i></span>
            <div>
              <h3>Ayuda y contacto</h3>
              <p>Comunícate con la línea gratuita de atención.</p>
            </div>
            <i class="bx bx-right-arrow-alt quick-arrow" aria-hidden="true"></i>
          </router-link>
        </div>
      </div>
    </section>

    <javascript-components />

    <section class="support-section" aria-labelledby="support-title">
      <div class="container">
        <div class="support-card">
          <div class="support-copy">
            <span class="section-kicker">Atención ciudadana</span>
            <h2 id="support-title">¿Necesitas ayuda con tu consulta?</h2>
            <p>
              Nuestro canal de atención puede orientarte sobre el beneficio y
              los puntos autorizados para el cobro.
            </p>
          </div>
          <div class="support-actions">
            <a href="tel:800103223" class="support-phone">
              <span>Línea gratuita</span>
              <strong>800 10 3223</strong>
            </a>
            <p class="support-hours">
              <strong>Horario de atención:</strong> lunes a viernes de 8:30 a 16:30
            </p>
            <router-link :to="{ name: 'public-contacts' }" class="support-link">
              Más información <i class="bx bx-right-arrow-alt"></i>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from "./components/Hero";
import JavascriptComponents from "./components/JavascriptComponents";
import paymentPeriodImage from "@/assets/bjp/bjp-periodo-entrega-2026.jpg";
import restrictionsImage from "@/assets/bjp/bjp-restricciones-cobro-2026.png";

export default {
  name: "main",
  components: {
    Hero,
    JavascriptComponents,
  },
  data() {
    return {
      paymentPeriodImage,
      restrictionsImage,
    };
  },
  methods: {
    zoomImage(src) {
      if (this.$viewerApi) this.$viewerApi({ images: [src] });
    },
  },
};
</script>

<style scoped>
.landing-page {
  color: var(--bjp-ink);
  font-family: "Poppins", sans-serif;
}

.information-section {
  position: relative;
  padding: clamp(4rem, 7vw, 6rem) 0;
  background: linear-gradient(
    180deg,
    rgba(6, 47, 54, 0.16),
    rgba(91, 69, 20, 0.12)
  );
}

.information-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 1.25rem;
}

.information-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  color: #ffffff;
  font-family: inherit;
  text-align: left;
  border: 1px solid rgba(230, 203, 114, 0.26);
  border-radius: 24px;
  background: rgba(6, 47, 54, 0.88);
  box-shadow: 0 20px 44px rgba(37, 41, 31, 0.16);
  cursor: zoom-in;
  transition: transform 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.information-card:hover,
.information-card:focus-visible {
  color: #ffffff;
  border-color: rgba(230, 203, 114, 0.56);
  box-shadow: 0 26px 52px rgba(37, 41, 31, 0.22);
  outline: none;
  transform: translateY(-5px);
}

.information-card img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #ffffff;
  object-fit: contain;
}

.information-card span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.2rem;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 750;
  gap: 1rem;
}

.information-card span i {
  color: var(--bjp-gold-400);
  font-size: 1.25rem;
}

.quick-section {
  position: relative;
  padding: clamp(4.5rem, 8vw, 7rem) 0;
  background: linear-gradient(
    180deg,
    rgba(6, 47, 54, 0.08),
    rgba(91, 69, 20, 0.16)
  );
}

.section-heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 480px);
  align-items: end;
  margin-bottom: 2.2rem;
  gap: 2rem;
}

.section-kicker {
  display: block;
  margin-bottom: 0.6rem;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.section-heading h2,
.support-copy h2 {
  margin: 0;
  color: var(--bjp-petrol-950);
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.05;
}

.section-heading > p {
  margin: 0;
  color: #ffffff;
  line-height: 1.7;
}

.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.quick-card {
  position: relative;
  display: flex;
  min-height: 240px;
  flex-direction: column;
  padding: 1.15rem;
  overflow: hidden;
  color: #ffffff;
  border: 1px solid rgba(230, 203, 114, 0.22);
  border-radius: 22px;
  background: rgba(6, 47, 54, 0.82);
  box-shadow: 0 18px 40px rgba(37, 41, 31, 0.12);
  transition: transform 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.quick-card::before {
  position: absolute;
  right: -4rem;
  bottom: -5rem;
  width: 11rem;
  height: 11rem;
  content: "";
  border: 1px solid rgba(230, 203, 114, 0.14);
  border-radius: 50%;
}

.quick-card:hover {
  color: #ffffff;
  text-decoration: none;
  border-color: rgba(230, 203, 114, 0.48);
  box-shadow: 0 24px 48px rgba(37, 41, 31, 0.2);
  transform: translateY(-7px);
}

.quick-card--featured {
  background: linear-gradient(145deg, rgba(6, 47, 54, 0.96), rgba(17, 81, 93, 0.9));
}

.quick-number {
  align-self: flex-end;
  color: #ffffff;
  font-family: monospace;
  font-size: 0.72rem;
  letter-spacing: 0.12em;
}

.quick-icon {
  display: grid;
  width: 48px;
  height: 48px;
  margin: 0.7rem 0 auto;
  color: #ffffff;
  font-size: 1.45rem;
  border: 1px solid rgba(230, 203, 114, 0.2);
  border-radius: 16px;
  background: rgba(230, 203, 114, 0.08);
  place-items: center;
}

.quick-card h3 {
  margin: 1rem 0 0.4rem;
  color: #ffffff;
  font-size: 1.08rem;
  font-weight: 750;
  line-height: 1.3;
}

.quick-card p {
  margin: 0;
  color: #ffffff;
  font-size: 0.83rem;
  line-height: 1.6;
}

.quick-arrow {
  position: absolute;
  right: 1.2rem;
  bottom: 1.1rem;
  color: #ffffff;
  font-size: 1.5rem;
  transition: transform 0.2s ease;
}

.quick-card:hover .quick-arrow {
  transform: translateX(4px);
}

.support-section {
  padding: clamp(4rem, 7vw, 6rem) 0;
  background: linear-gradient(180deg, rgba(6, 47, 54, 0.18), rgba(91, 69, 20, 0.12));
}

.support-card {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  padding: clamp(2rem, 5vw, 4rem);
  overflow: hidden;
  color: #ffffff;
  border: 1px solid rgba(230, 203, 114, 0.26);
  border-radius: 30px;
  background: linear-gradient(135deg, rgba(6, 47, 54, 0.96), rgba(17, 81, 93, 0.86));
  box-shadow: 0 24px 54px rgba(37, 41, 31, 0.2);
  gap: 3rem;
}

.support-card::after {
  position: absolute;
  top: -10rem;
  right: -7rem;
  width: 24rem;
  height: 24rem;
  content: "";
  border: 1px solid rgba(230, 203, 114, 0.15);
  border-radius: 50%;
}

.support-copy {
  position: relative;
  z-index: 1;
  max-width: 680px;
}

.support-copy .section-kicker {
  color: #ffffff;
}

.support-copy h2 {
  color: var(--bjp-gold-400);
}

.support-copy p {
  max-width: 600px;
  margin: 1rem 0 0;
  color: #ffffff;
  line-height: 1.7;
}

.support-actions {
  position: relative;
  z-index: 1;
  display: flex;
  min-width: 250px;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.9rem;
}

.support-phone {
  display: flex;
  flex-direction: column;
  color: #ffffff;
}

.support-phone:hover {
  color: #ffffff;
  text-decoration: none;
}

.support-phone span {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.support-phone strong {
  margin-top: 0.15rem;
  color: var(--bjp-gold-400);
  font-size: clamp(1.7rem, 3vw, 2.4rem);
  line-height: 1;
}

.support-hours {
  margin: 0;
  color: #ffffff;
  font-size: 0.82rem;
  line-height: 1.5;
}

.support-hours strong {
  color: var(--bjp-gold-400);
}

.support-link {
  display: inline-flex;
  align-items: center;
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 750;
  gap: 0.35rem;
}

.support-link:hover {
  color: #ffffff;
  text-decoration: none;
}

@media (max-width: 1100px) {
  .quick-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quick-card {
    min-height: 225px;
  }
}

@media (max-width: 767px) {
  .information-section,
  .quick-section,
  .support-section {
    padding: 3.25rem 0;
  }

  .section-heading,
  .support-card,
  .information-grid {
    grid-template-columns: 1fr;
  }

  .section-heading {
    align-items: start;
    margin-bottom: 1.5rem;
    gap: 1rem;
  }

  .section-heading h2,
  .support-copy h2 {
    font-size: clamp(1.8rem, 8vw, 2.4rem);
    overflow-wrap: anywhere;
  }

  .information-grid {
    gap: 1rem;
  }

  .information-card {
    width: 100%;
    max-width: 100%;
    border-radius: 18px;
  }

  .information-card img {
    height: auto;
    aspect-ratio: auto;
  }

  .support-card {
    padding: 1.75rem;
    gap: 2rem;
  }

  .support-actions {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 640px) {
  .quick-grid {
    grid-template-columns: 1fr;
  }

  .quick-card {
    min-height: 195px;
  }

  .support-card {
    border-radius: 22px;
  }
}

@media (max-width: 400px) {
  .information-section,
  .quick-section,
  .support-section {
    padding: 2.5rem 0;
  }

  .landing-page .container {
    padding-right: 0.85rem;
    padding-left: 0.85rem;
  }

  .section-kicker {
    font-size: 0.66rem;
    letter-spacing: 0.12em;
  }

  .section-heading h2,
  .support-copy h2 {
    font-size: 1.72rem;
    line-height: 1.12;
  }

  .section-heading > p,
  .support-copy p {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .information-card {
    border-radius: 15px;
  }

  .information-card span {
    padding: 0.85rem 1rem;
    font-size: 0.82rem;
  }

  .quick-card {
    min-height: 185px;
    border-radius: 18px;
  }

  .support-card {
    padding: 1.35rem;
    border-radius: 18px;
  }

  .support-phone strong {
    font-size: 1.7rem;
  }

  .support-hours strong {
    display: block;
    margin-bottom: 0.15rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .quick-card,
  .quick-arrow,
  .information-card {
    transition: none;
  }
}
</style>
